import { serviceRequest } from './service-request';

export type FormTemplate = {
	Id?: string;
	InternalName?: string;
	Name?: string;
	Description?: string;
	FormsUrl?: string;
	EmbedUrl?: string;
	Categories?: string[];
	Features?: string[];
	RouteName?: string;
}

export function getSharedTemplates(org : string) {
	return serviceRequest('svc/templates/shared', null, { method: 'GET', query: { org } });
}

export function getSharedTemplate(org : string, formId : string) {
	return serviceRequest('svc/templates/shared/template', null, { method: 'GET', query: { org, formId } });
}

export function getMinimumPlan(org : string, formId : string) {
	return serviceRequest('svc/templates/minimum-plan', null, { method: 'GET', query: { org, formId } });
}

export type SearchHitImages = {
	main: string | null;
	main_b64: string | null;
	capture: string | null;
}

export type SearchHit = {
	id: string;
	url: string;
	title: string;
	meta_description: string | null;
	meta_categories: string[] | null;
	custom_fields: Record<string, string | string[]>;
	highlight: string;
	ts: string;
	categories: string[];
	document_type: 'html' | 'pdf' | 'doc' | 'docx' | 'ppt' | 'pptx';
	images: SearchHitImages;
	score: number;
}

export type SearchResponse = {
	page: number;
	total_hits: number;
	processing_time_ms: number;
	hits: SearchHit[];
	facets: Record<string, string> | null;
	rangeFacets: Record<string, string> | null;
}

export function searchTemplates(query: string, fuzzy: boolean): Promise<SearchResponse> {
	return fetch(`https://api.addsearch.com/v1/search/a2c6b2bf4cf593459133fa07e47145dd?term=${query}&categories=1xtemplates&fuzzy=${fuzzy}&limit=50`)
		.then(res => res.json());
}